<template>
  <div class="m-header-search" @click="onClick">
    <img v-show="iconType=== 1" :src="mode === 'light' ? '/image/icon/up-linear.svg' : '/image/icon/arrow-up-white.svg'">
    <img v-show="iconType=== 0" :src="mode === 'light' ? '/image/icon/down-linear.svg' : '/image/icon/arrow-down-white.svg'">
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, ref } from 'vue'

export default defineComponent({
  props: {
    type: {
      type: Number,
      default: 0
    },
    mode: {
      default: 'light'
    }
  },
  emits: ['click'],
  setup (props: any, context: any) {
    const { emit } = context
    const iconType = ref(props.type)

    const onClick = () => {
      emit('click', iconType.value)
      iconType.value = iconType.value === 0 ? 1 : 0
    }

    watch(() => props.type, (t) => {
      iconType.value = t
    })

    return {
      onClick,
      iconType
    }
  }
})
</script>
<style lang="less">
  .m-header-search {
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border: none;
  }

</style>
